
const canvas = new fabric.Canvas("image-canvas");

const appState = {
  outerMargin: 0,
  innerPadding: 10,
  innerWidth: 400,
  innerHeight: 400,
  selectedWidth: 400,
  selectedHeight: 40,
  uploadedImage: null,
  scaleFactor: 1,
  angle: 0,
  zoom: 1.0,
  minZoom: 5,
  maxZoom: 5,
  clipPath: null,
  outerFrame: null,
  innerCanvas: null,
  borderSize: 0.75,
  borderColor: "#000000",
  canvasBgColor: "#ffffff",
  canvasBorderColor: "#ffffff",
  canvasWidth: 0,
  canvasHeight: 0,
  newCanvasWidth: 0,
  newCanvasHeight: 0,
  frameColor: "#000",
  imageFinall: 0,
  imageFinalt: 0,
  imageFinalh: 0,
  imageFinalW: 0,
  imageWidth: 0,
  imageHeight: 0,
  newimageleft: 0,
  newimagetop: 0,
  border: 0,
  selectedEdgeType: "FitToEdge",
};

// ===========================================
// PINCH TO ZOOM FUNCTIONALITY FOR MOBILE
// ===========================================
// Variables for pinch zoom
let initialDistance = 0;
let initialZoom = 1;
let lastCenter = { x: 0, y: 0 };
let isPinching = false;
let lastTouchTime = 0;

const uploadInput = document.getElementById("upload-image");
const uploadInputwrap = document.querySelector(".upload-wrapper");
const galleryWrapper = document.getElementById("galleryWrapper");
const customForm = document.getElementById("custom-image-form");

canvas.on("object:scaling", function() {
  updateMovementConstraints();
  updatePositionInfo();
});

canvas.on("object:rotating", function() {
  updateMovementConstraints();
  updatePositionInfo();
});



function getImagePosition() {
  if (!appState.uploadedImage) return null;

  const img = appState.uploadedImage;
  const left = img.left - img.getScaledWidth() / 2;
  const top = img.top - img.getScaledHeight() / 2;
  const right = left + img.getScaledWidth();
  const bottom = top + img.getScaledHeight();

  return {
    left: left,
    top: top,
    right: right,
    bottom: bottom,
    width: img.getScaledWidth(),
    height: img.getScaledHeight(),
    scale: (img.scaleX * 100)/ 100,
    angle: img.angle,
  };
}


function setMovementConstraints() {
  if (!appState.uploadedImage) return;
  
  const img = appState.uploadedImage;
  const width = img.getScaledWidth();
  const height = img.getScaledHeight();
  const isLandscape = width > height;
  const isPortrait = height > width;
  const isSquare = width === height;
  
  // if (isLandscape) {
  //   img.set({
  //     lockMovementX: false,
  //     lockMovementY: true
  //   });
  // } else if (isPortrait) {
  //   img.set({
  //     lockMovementX: true,
  //     lockMovementY: false
  //   });
  // } else {
  //   img.set({
  //     lockMovementX: false,
  //     lockMovementY: false
  //   });
  // }
  img.setCoords();
  canvas.requestRenderAll();
}

function updateMovementConstraints() {
  if (!appState.uploadedImage) return;
  
  const img = appState.uploadedImage;
  const width = img.getScaledWidth();
  const height = img.getScaledHeight(); 
  const isLandscape = width > height;
  const isPortrait = height > width;
  
  // if (isLandscape) {
  //   img.set({
  //     lockMovementX: false,
  //     lockMovementY: true
  //   });
  // } else if (isPortrait) {
  //   img.set({
  //     lockMovementX: true,
  //     lockMovementY: false
  //   });
  // } else {
  //   img.set({
  //     lockMovementX: false,
  //     lockMovementY: false
  //   });
  // }
  
  img.setCoords();
}


document.addEventListener("DOMContentLoaded", function () {
  const boostBtn = document.querySelector(".boost-img-btn");
  const conformBtn = document.querySelector(".image-conform-btn");

  if (!boostBtn || !conformBtn) return;

  function updateDisplay() {
    const boostDisplay = window.getComputedStyle(boostBtn).display;

    if (boostDisplay === "none") {
      conformBtn.style.display = "flex";
    } else if (boostDisplay === "flex") {
      conformBtn.style.display = "none";
    }
  }

  updateDisplay();

  const observer = new MutationObserver(updateDisplay);

  observer.observe(boostBtn, {
    attributes: true,
    attributeFilter: ["style", "class"], 
    subtree: false
  });
  let resizeTimeout;
  window.addEventListener("resize", updateDisplay);
});

function updatePositionInfo() {
  const pos = getImagePosition();
  if (!pos) return;

  document.getElementById("position-left").textContent = `${pos.left}`;
  document.getElementById("position-top").textContent = `${pos.top}`;
  document.getElementById("position-right").textContent = `${pos.right}`;
  document.getElementById("position-bottom").textContent = `${pos.bottom}`;
  document.getElementById("img-width").textContent = `${pos.width}`;
  document.getElementById("img-height").textContent = `${pos.height}`;
  document.getElementById("img-scale").textContent = pos.scale;
  document.getElementById("img-angle").textContent = `${pos.angle}°`;

  const imgwidth = pos.width || 0;
  const imgheight = pos.height || 0;
  const rvalue = document.getElementById("r")?.textContent || 1;
  const imgtop = pos.top || 0;
  const imgleft = pos.left || 0;
  const imageratio = Number((imgwidth / imgheight).toFixed(2));
  const cvswElement = document.getElementById("cvs-w")?.textContent || 0;
  const cvshElement = document.getElementById("cvs-h")?.textContent || 0;
  const finalw = (imgwidth * rvalue);
  appState.imageFinalW = finalw;
  const finalh = (imgheight * rvalue);
  appState.imageFinalh = finalh;
  const finalt = (imgtop * rvalue);
  appState.imageFinalt = finalt;
  const finall = (imgleft * rvalue);
  appState.imageFinall = finall;
  const currentimgw = finalw / 96;
  const currentimgh = finalh / 96;

  const filewvalue = document.getElementById("img-file-w")?.textContent || 0;
  const filehvalue = document.getElementById("img-file-h")?.textContent || 0;

  const dpiW = filewvalue && currentimgw ? filewvalue / currentimgw : 0;
  const dpiH = filehvalue && currentimgh ? filehvalue / currentimgh : 0;
  const dpi = (dpiW + dpiH) / 2;
  appState.finall = finall;
  appState.finalt = finalt;
  appState.finalw= finalw;
  appState.finalh = finalh;
  appState.dpi = dpi;
  appState.printimghight = currentimgh;
  appState.printimgwidth = currentimgw;
    appState.imageWidth = filewvalue;
  appState.imageheight = filehvalue;
  updateDpiDisplay();
  document.getElementById("final-dpi").textContent = dpi.toFixed(2);
  document.getElementById("img-f-w").textContent = finalw;
  document.getElementById("img-f-h").textContent = finalh;
  document.getElementById("f-t").textContent = finalt;
  document.getElementById("f-l").textContent = finall;
   document.getElementById("img-ratio").textContent = imageratio;
  document.getElementById("current-img-w").textContent = currentimgw;
  document.getElementById("current-img-h").textContent = currentimgh;

  const hiddenimg = document.getElementById("frame-img-position");
      const orientationRadio = document.querySelector('input[name="orientation"]:checked');
    const orientation = orientationRadio ? orientationRadio.value : "portrait";
    if(orientation == "portrait"){
        if (hiddenimg) {
                hiddenimg.value = JSON.stringify({
                 area_width: cvswElement,
                  area_height: cvshElement,
                  width: finalw,
                  height: finalh,
                  top: finalt,
                  left: finall,
                });
              }
    }
    else if(orientation == "landscape"){
      if (hiddenimg) {
                hiddenimg.value = JSON.stringify({
                  area_width: cvshElement,
                  area_height: cvswElement,
                  width: finalw,
                  height: finalh,
                  top: finalt,
                  left: finall,
                });
              }
    }
}

function gcd(a, b) {
  return b === 0 ? a : gcd(b, a % b);
}

const dpiElement = document.querySelector(".dpi-num");
const iconElement = document.querySelector(".dpi-state-icon");



function updateDpiDisplay() {

  const dpiElement = document.querySelector(".dpi-num");
  const iconElements = document.querySelectorAll(".dpi-state-icon");
  const boostBtn = document.querySelector(".boost-img-btn");
  const confirmBtn = document.querySelector(".image-conform-btn");

  const currentDpi = Number((appState.dpi || 0).toFixed(2));

  if (!dpiElement || !iconElements.length || !boostBtn) return;

  // Clear all icons first
  iconElements.forEach(el => {
    el.innerHTML = "";
  });

  if (currentDpi > 0 && currentDpi < 30) {
    dpiElement.textContent = `Needs Upscale`;
    dpiElement.style.color = "red";

    iconElements.forEach(el => {
      el.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.9891 0C4.49317 0 0 4.49317 0 9.9891C0 15.4859 4.49317 20 9.9891 20C15.485 20 20 15.5068 20 9.9891C20 4.47115 15.5068 0 9.9891 0ZM9.9891 18.3208C5.40912 18.3208 1.67946 14.5911 1.67946 10.0111C1.67946 5.43115 5.40912 1.70148 9.9891 1.70148C14.5691 1.70148 18.2987 5.43115 18.2987 10.0111C18.3207 14.5911 14.5909 18.3208 9.9891 18.3208Z" fill="#FF0606"/>
      <path d="M10.1207 4.56252C9.74952 4.56252 9.44421 4.69326 9.20466 4.93365C8.98621 5.1732 8.85547 5.52239 8.85547 5.93651C8.85547 6.24185 8.8774 6.72177 8.92126 7.41931L9.16081 10.9307C9.20466 11.4106 9.29154 11.7379 9.37926 11.9774C9.48806 12.2389 9.70651 12.3696 10.0118 12.3696C10.3172 12.3696 10.5137 12.2389 10.6444 11.9774C10.7532 11.7379 10.841 11.3887 10.8629 10.9526L11.1682 7.33156C11.2121 7.0043 11.2121 6.65511 11.2121 6.34977C11.2121 5.78297 11.1463 5.34691 10.9936 5.04073C10.884 4.7371 10.5787 4.56252 10.1207 4.56252Z" fill="#FF0606"/>
      <path d="M10.0549 13.4844C9.72761 13.4844 9.44421 13.5932 9.20466 13.8336C8.96511 14.0731 8.85547 14.3354 8.85547 14.6627C8.85547 15.0338 8.9862 15.3391 9.2266 15.5348C9.46615 15.7313 9.75039 15.8402 10.0768 15.8402C10.3821 15.8402 10.6655 15.7313 10.9059 15.5129C11.1455 15.2944 11.277 14.6408 11.277 14.6408C11.277 14.3135 11.1682 14.0301 10.9278 13.7906C10.6655 13.5932 10.3813 13.4844 10.0549 13.4844Z" fill="#FF0606"/>
    </svg>`;
    });

    boostBtn.style.display = "flex";
    boostBtn.classList.add("show");

  } else if (currentDpi >= 30) {
   dpiElement.textContent = `Good To Print`;
    dpiElement.style.color = "green";

    iconElements.forEach(el => {
      el.innerHTML =`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 0C4.48421 0 0 4.48421 0 10C0 15.5158 4.48421 20 10 20C15.5158 20 20 15.5158 20 10C20 4.48421 15.5158 0 10 0ZM10 17.8105C5.68421 17.8105 2.18947 14.2947 2.18947 10C2.18947 5.70526 5.68421 2.18947 10 2.18947C14.3158 2.18947 17.8105 5.68421 17.8105 10C17.8105 14.3158 14.3158 17.8105 10 17.8105Z" fill="#1B8600"/>
<path d="M12.7139 6.92258L8.90337 10.7542L7.28232 9.13311C6.86127 8.71205 6.16653 8.71205 5.74548 9.13311C5.32442 9.55416 5.32442 10.2489 5.74548 10.6699L8.14548 13.0699C8.356 13.2805 8.62969 13.3857 8.92443 13.3857C9.21916 13.3857 9.49285 13.2805 9.70337 13.0699L14.2928 8.48047C14.7139 8.05942 14.7139 7.36469 14.2928 6.94363C13.8507 6.50153 13.156 6.50153 12.7139 6.92258Z" fill="#1B8600"/>
</svg>`;

    });

    boostBtn.classList.remove("show");
    boostBtn.style.display = "none";

  } else if (currentDpi === 0) {
    boostBtn.classList.remove("show");

    setTimeout(() => {
      if (!boostBtn.classList.contains("show")) {
        boostBtn.style.display = "none";
        if (confirmBtn) {
          confirmBtn.style.display = "flex";
        }
      }
    }, 300);
  }
}

function updateFrameFromPixels(width, height, width1, height1) {
  canvas.setWidth(width + appState.outerMargin * 2);
  canvas.setHeight(height + appState.outerMargin * 2);

  const frnheight = appState.originalHeight;
  const frmwidth = appState.originalWidth;
  let size = `${frmwidth}x${frnheight}`;
  const sortedSize = [frmwidth, frnheight].sort((a, b) => a - b).join("x");

  let innerPadding;

  if (window.innerWidth < 680) {
    switch (sortedSize) {
      case "1056x1248": innerPadding = 144 / 6.24; break;
      case "1152x1440": innerPadding = 144 / 7.2; break;
      case "1344x1632": innerPadding = 144 / 8.16; break;
      case "1440x1440": innerPadding = 144 / 7.2; break;
      case "1440x1824": innerPadding = 144 / 9.12; break;
      case "1440x2016": innerPadding = 144 / 10.08; break;
      case "1824x1824": innerPadding = 144 / 9.12; break;
      case "1824x2208": innerPadding = 144 / 11.04; break;
      case "2016x2592": innerPadding = 144 / 12.96; break;
      case "2208x2976": innerPadding = 144 / 14.88; break;
      case "2208x3168": innerPadding = 144 / 15.84; break;
      case "2592x3360": innerPadding = 144 / 16.8; break;
      case "2592x3744": innerPadding = 144 / 18.72; break;
      default: innerPadding = null;
    }
  } else {
    switch (sortedSize) {
      case "1056x1248": innerPadding = 144 / 3.12; break;
      case "1152x1440": innerPadding = 144 / 3.6; break;
      case "1344x1632": innerPadding = 144 / 4.08; break;
      case "1440x1440": innerPadding = 144 / 3.6; break;
      case "1440x1824": innerPadding = 144 / 4.56; break;
      case "1440x2016": innerPadding = 144 / 5.04; break;
      case "1824x1824": innerPadding = 144 / 4.56; break;
      case "1824x2208": innerPadding = 144 / 5.52; break;
      case "2016x2592": innerPadding = 144 / 6.48; break;
      case "2208x2976": innerPadding = 144 / 7.44; break;
      case "2208x3168": innerPadding = 144 / 7.92; break;
      case "2592x3360": innerPadding = 144 / 8.4; break;
      case "2592x3744": innerPadding = 144 / 9.36; break;
      default: innerPadding = null;
    }
  }

  appState.innerWidth = width - innerPadding * 2;
  appState.innerHeight = height - innerPadding * 2;

  canvas.clear();
  canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));

  if (appState.uploadedImage) {
    appState.uploadedImage.clipPath = null;
    appState.uploadedImage.originX = 0;
    appState.uploadedImage.originY = 0;
    appState.uploadedImage.left = 0;
    appState.uploadedImage.top = 0;
    appState.uploadedImage.scaleToWidth(width);
    appState.uploadedImage.scaleToHeight(height);

    canvas.add(appState.uploadedImage);
    canvas.setActiveObject(appState.uploadedImage);
  }

  appState.borderSize = innerPadding;

  /* ================= STRIPE PATTERN HELPER ================= */
function createWrappedStripePattern(
  ctx,
  {
    stripeWidth = 20,
    stripeHeight = 1000,
    stripeGap = 20,
    angle = 45,
    stripeColor = "#c8c8c8",
    stripeOpacity = 1,
  } = {}
) {
  const tileSize = 400;

  const pCanvas = document.createElement("canvas");
  pCanvas.width = tileSize;
  pCanvas.height = tileSize;

  const pctx = pCanvas.getContext("2d");

  /* ================= BACKGROUND ================= */
const frmcolor =  appState.frameColor

  pctx.fillStyle = frmcolor;
  pctx.fillRect(0, 0, tileSize, tileSize);

  /* ================= ROTATION ================= */
  pctx.translate(tileSize / 2, tileSize / 2);
  pctx.rotate((angle * Math.PI) / 180);
  pctx.translate(-tileSize / 2, -tileSize / 2);


  /* ================= STRIPES ================= */
  if(frmcolor === "#000"){
    pctx.fillStyle = "#333";
    pctx.globalAlpha = 1;
  }
  else if(frmcolor === "#FFFFFF"){
    pctx.fillStyle = "#c8c8c8";
    pctx.globalAlpha = 0.5;
  }
  else{
   pctx.fillStyle = stripeColor;
   pctx.globalAlpha = 0.5;
  }

  for (
    let x = -tileSize;
    x <= tileSize * 2;
    x += stripeWidth + stripeGap
  ) {
    pctx.fillRect(
      x,
      (tileSize - stripeHeight) / 2,
      stripeWidth,
      stripeHeight
    );
  }

  pctx.globalAlpha = 1;

  return ctx.createPattern(pCanvas, "repeat");
}

  function drawBorderOnTop() {
    const ctx = canvas.contextTop;
    if (!ctx) return;

    canvas.clearContext(canvas.contextTop);

    const bw = canvas.getWidth();
    const bh = canvas.getHeight();
    const borderSize = appState.borderSize;
    const dashOffset = 0.5;

    ctx.save();

    /* ================= STRIPED FRAME ================= */
    const stripePattern = createWrappedStripePattern(ctx);

    ctx.fillStyle = stripePattern;

    // top
    ctx.fillRect(0, 0, bw, borderSize + 1);
    // bottom
    ctx.fillRect(0, bh - (borderSize + 1), bw, borderSize + 1);
    // left
    ctx.fillRect(0, borderSize, borderSize, bh - borderSize * 2);
    // right
    ctx.fillRect(bw - borderSize, borderSize, borderSize, bh - borderSize * 2);

    /* ================= DASH GUIDES ================= */
  
  ctx.setLineDash([5, 2]);
  ctx.lineWidth = 0.5;
    ctx.strokeStyle = "#ffffff";

    const o = dashOffset;

    ctx.beginPath();
    ctx.moveTo(o, o);
    ctx.lineTo(bw - o, o);
    ctx.lineTo(bw - o, bh - o);
    ctx.lineTo(o, bh - o);
    ctx.closePath();
    ctx.stroke();

    const i = borderSize + 0.5;

    ctx.beginPath();
    ctx.moveTo(i, i);
    ctx.lineTo(bw - i, i);
    ctx.lineTo(bw - i, bh - i);
    ctx.lineTo(i, bh - i);
    ctx.closePath();
    ctx.stroke();

    ctx.setLineDash([]);

    /* ================= LABEL ================= */
    const frmcolor =  appState.frameColor;
    
    if(frmcolor === "#FFFFFF"){
 ctx.fillStyle = "#000";
    }
    else{
       ctx.fillStyle = "#ffffff";
    }
   
    // ctx.font = "8px Arial";
    // ctx.textAlign = "center";
    // ctx.textBaseline = "middle";
    // ctx.fillText("SIDES AND BACK IN FRAME COLOR", bw / 2, borderSize / 2);

    ctx.restore();
  }

  window.drawBorderOnTop = drawBorderOnTop;
  canvas.off("after:render");
  canvas.on("after:render", drawBorderOnTop);
  canvas.requestRenderAll();

  updatePositionInfo();
}


function updateFrameSize(selectedOption) {
  // Get orientation
  const selectedRadio = document.querySelector('input[name="orientation"]:checked');
    const selectedOrientation = selectedRadio ? selectedRadio.value : "portrait";
   const selectedsize = document.querySelector('input[name="frameSize"]:checked');
    // Get frame size data from selected option
    const originalsize = selectedOption.getAttribute("data-original-size");
    const [width1, height1] = originalsize.split("x").map(Number);

  document.querySelectorAll(".selected-size").forEach(el => {
    el.textContent = selectedsize.value;
  });
    let dataratio;
 let size;
  if (window.innerWidth < 680) {
    size = selectedOption.getAttribute("data-pixel-mobile");
    dataratio = selectedOption.getAttribute("data-ratio-mobile");
  } else {
    size = selectedOption.getAttribute("data-pixel-desktop");
    dataratio = selectedOption.getAttribute("data-ratio-desktop");
  }
//const size = selectedOption.getAttribute("data-size");
  const frmsize = selectedOption.getAttribute("data-frmsize");
  const [width, height] = size.split("x").map(Number);
  const [frmwidth, frmheight] = frmsize.replace(/″/g, '').split('×').map(s => Number(s.trim()));
  


  const extendwidth = frmwidth + 3;
  const extendheight = frmheight + 3;

  // Set values based on orientation
    if (selectedOrientation === "portrait") {
        appState.originalWidth = width1;
        appState.originalHeight = height1;
        appState.selectedWidth = width;
        appState.selectedHeight = height;
        appState.extendheight = extendheight;
        appState.extendwidth = extendwidth;
    } else { // landscape
        appState.originalWidth = height1; 
        appState.originalHeight = width1;
        appState.selectedWidth = height;
        appState.selectedHeight = width;
        appState.extendheight = extendwidth;
        appState.extendwidth = extendheight;
    }

     // Update UI elements
    updateFrameFromPixels(appState.selectedWidth, appState.selectedHeight, appState.originalWidth, appState.originalHeight);
    
  
    const cvswElement = document.getElementById("cvs-w");
    const cvshElement = document.getElementById("cvs-h");
    const orgWElement = document.getElementById("org-w");
    const orgHElement = document.getElementById("org-h");
    const frnWElement = document.getElementById("frm-w");
    const frmHElement = document.getElementById("frm-h");
    const ratioElement = document.getElementById("r");
       const bordersizeElement = document.getElementById("brd-size");
    const borderColorElement = document.getElementById("brd-color");

    
    if (orgWElement) orgWElement.textContent = appState.originalWidth;
    if (orgHElement) orgHElement.textContent = appState.originalHeight;
    if (frnWElement) frnWElement.textContent = appState.selectedWidth;
    if (frmHElement) frmHElement.textContent = appState.selectedHeight;
    if (ratioElement) ratioElement.textContent = dataratio;
    if (cvswElement) cvswElement.textContent = appState.originalWidth;
    if (cvshElement) cvshElement.textContent = appState.originalHeight;
    if (bordersizeElement) bordersizeElement.textContent = appState.borderSize ;
  if (borderColorElement) borderColorElement.textContent = appState.frameColor;

    
    // Handle canvas updates
    canvas.setWidth(appState.selectedWidth);
    canvas.setHeight(appState.selectedHeight);
    
    // Update all canvas objects
    canvas.getObjects().forEach(obj => {
        obj.set({
            scaleX: obj.scaleX,
            scaleY: obj.scaleY,
            left: obj.left,
            top: obj.top
        });
        obj.setCoords();
    });
    
    canvas.renderAll();
    
    // Handle uploaded image if exists
    if (appState.uploadedImage) {
        appState.uploadedImage.clipPath = appState.clipPath;
        canvas.add(appState.uploadedImage);
         coverFrame();
    }
    

  updatePositionInfo();

  // Update DPI display
  updateDPIDisplay();
}

// Function to handle orientation radio button changes
function handleOrientationChange() {
    // Get the currently selected frame size option
    const selectedSizeOption = document.querySelector('#frameSizeOptions [name="frameSize"]:checked');
    if (selectedSizeOption) {
        updateFrameSize(selectedSizeOption);
    }
}

// Event listeners
document.getElementById("frameSizeOptions").addEventListener("change", function(e) {
    if (e.target.name === "frameSize") {
        updateFrameSize(e.target);
    }
});



// Helper function for DPI display (extracted from main function)
function updateDPIDisplay() {

  const dpiElement = document.querySelector(".dpi-num");
  const iconElement = document.querySelector(".dpi-state-icon");
  const boostBtn = document.querySelector(".boost-img-btn");
  const confirmBtn = document.querySelector(".image-conform-btn");

  const currentDpi = Number((appState.dpi || 0).toFixed(2));

  if (!dpiElement || !iconElement || !boostBtn) return;

  iconElement.innerHTML = ""; 

  if (currentDpi > 0 && currentDpi < 30) {
  dpiElement.textContent = `Needs Upscale`;
    dpiElement.style.color = "red";

     iconElement.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.9891 0C4.49317 0 0 4.49317 0 9.9891C0 15.4859 4.49317 20 9.9891 20C15.485 20 20 15.5068 20 9.9891C20 4.47115 15.5068 0 9.9891 0ZM9.9891 18.3208C5.40912 18.3208 1.67946 14.5911 1.67946 10.0111C1.67946 5.43115 5.40912 1.70148 9.9891 1.70148C14.5691 1.70148 18.2987 5.43115 18.2987 10.0111C18.3207 14.5911 14.5909 18.3208 9.9891 18.3208Z" fill="#FF0606"/>
      <path d="M10.1207 4.56252C9.74952 4.56252 9.44421 4.69326 9.20466 4.93365C8.98621 5.1732 8.85547 5.52239 8.85547 5.93651C8.85547 6.24185 8.8774 6.72177 8.92126 7.41931L9.16081 10.9307C9.20466 11.4106 9.29154 11.7379 9.37926 11.9774C9.48806 12.2389 9.70651 12.3696 10.0118 12.3696C10.3172 12.3696 10.5137 12.2389 10.6444 11.9774C10.7532 11.7379 10.841 11.3887 10.8629 10.9526L11.1682 7.33156C11.2121 7.0043 11.2121 6.65511 11.2121 6.34977C11.2121 5.78297 11.1463 5.34691 10.9936 5.04073C10.884 4.7371 10.5787 4.56252 10.1207 4.56252Z" fill="#FF0606"/>
      <path d="M10.0549 13.4844C9.72761 13.4844 9.44421 13.5932 9.20466 13.8336C8.96511 14.0731 8.85547 14.3354 8.85547 14.6627C8.85547 15.0338 8.9862 15.3391 9.2266 15.5348C9.46615 15.7313 9.75039 15.8402 10.0768 15.8402C10.3821 15.8402 10.6655 15.7313 10.9059 15.5129C11.1455 15.2944 11.277 14.6408 11.277 14.6408C11.277 14.3135 11.1682 14.0301 10.9278 13.7906C10.6655 13.5932 10.3813 13.4844 10.0549 13.4844Z" fill="#FF0606"/>
    </svg>`;

    boostBtn.style.display = "flex";
    boostBtn.classList.add("show");

  } else if (currentDpi >= 30) {
   dpiElement.textContent = `Good To Print`;
    dpiElement.style.color = "green";

    iconElement.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 0C4.48421 0 0 4.48421 0 10C0 15.5158 4.48421 20 10 20C15.5158 20 20 15.5158 20 10C20 4.48421 15.5158 0 10 0ZM10 17.8105C5.68421 17.8105 2.18947 14.2947 2.18947 10C2.18947 5.70526 5.68421 2.18947 10 2.18947C14.3158 2.18947 17.8105 5.68421 17.8105 10C17.8105 14.3158 14.3158 17.8105 10 17.8105Z" fill="#1B8600"/>
<path d="M12.7139 6.92258L8.90337 10.7542L7.28232 9.13311C6.86127 8.71205 6.16653 8.71205 5.74548 9.13311C5.32442 9.55416 5.32442 10.2489 5.74548 10.6699L8.14548 13.0699C8.356 13.2805 8.62969 13.3857 8.92443 13.3857C9.21916 13.3857 9.49285 13.2805 9.70337 13.0699L14.2928 8.48047C14.7139 8.05942 14.7139 7.36469 14.2928 6.94363C13.8507 6.50153 13.156 6.50153 12.7139 6.92258Z" fill="#1B8600"/>
</svg>`;

    boostBtn.classList.remove("show");
    boostBtn.style.display = "none";

  } else if (currentDpi === 0) {
    boostBtn.classList.remove("show");

    setTimeout(() => {
      if (!boostBtn.classList.contains("show")) {
        boostBtn.style.display = "none";
        if (confirmBtn) {
          confirmBtn.style.display = "flex";
        }
      }
    }, 300);
  }
}

document.getElementById("frameSizeOptions").addEventListener("change", function(e) {
  if (e.target.name === "frameSize") {
    updateFrameSize(e.target);
  }
});



window.addEventListener("load", () => {
  const selectedOption = document.querySelector('#frameSizeOptions [name="frameSize"]:checked');
  if (selectedOption) {
    updateFrameSize(selectedOption);
  }
});


function showCenterGuidelines(obj) {
  canvas.getObjects('line').forEach(line => canvas.remove(line));

  const centerX = canvas.width / 2;
  const centerY = canvas.height / 2;

  const objCenter = obj.getCenterPoint();
  const threshold = 0;

  if (Math.abs(objCenter.x - centerX) < threshold) {
    const vLine = new fabric.Line([centerX, obj.top - obj.height / 2, centerX, obj.top + obj.height / 2], {
      stroke: 'red',
      strokeWidth: 1,
      selectable: false,
      evented: false,
      opacity: 0.7
    });
    canvas.add(vLine);
    canvas.moveTo(vLine, 999); 
  }

  if (Math.abs(objCenter.y - centerY) < threshold) {
    const hLine = new fabric.Line([obj.left - obj.width / 2, centerY, obj.left + obj.width / 2, centerY], {
      stroke: 'red',
      strokeWidth: 1,
      selectable: false,
      evented: false,
      opacity: 0.7
    });
    canvas.add(hLine);
    canvas.moveTo(hLine, 999);
  }

  canvas.renderAll();
}

canvas.on('object:moving', function(e) {
  const obj = e.target;
   updatePositionInfo();
  showCenterGuidelines(obj);
    canvas.getObjects('line').forEach(line => canvas.bringToFront(line));

});

canvas.on('object:modified', function(e) {
  canvas.getObjects('line').forEach(line => canvas.remove(line));
  canvas.renderAll();
  updatePositionInfo();
});

function uploadImageToAPI(file) {
  const formData = new FormData();
  const userId = window.shopifyCustomerId || "guest";
    const sessionId = getLocalStorage1Day("sessionId") || "none";
 formData.append('file', file);
    formData.append('customerId', userId);
    formData.append('sessionId', sessionId);
     formData.append('megamenu', "true");
  fetch(`${window.Prompt2Prints.apiBase}/upload-image`, {
    method: "POST",
              headers: {
        "x-api-key": window.Prompt2Prints.apiKey
      },
    body: formData
  })
  .then(res => res.json())
  .then(data => {
    // ✅ Store cloudfrontLink in localStorage
      if (data?.cloudfrontLink) {
        localStorage.setItem("pdpUploadedImage", data.cloudfrontLink);
      } else {
        console.warn("cloudfrontLink not found in API response");
      }
  })
  .catch(err => {
    console.error("Image upload failed:", err);
  });
}





window.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const toolParam = params.get("tool");
  const syncmodeparam = params.get("syncMode");

  const firstSelected = document.querySelector("#frameSizeOptions input[name=\"frameSize\"]:checked") || document.querySelector("#frameSizeOptions input[name=\"frameSize\"]");

  if (firstSelected) {
    const [width, height] = firstSelected.getAttribute("data-size").split("x").map(Number);
    appState.selectedWidth = width;
    appState.selectedHeight = height;
     updateFrameFromPixels(appState.selectedWidth, appState.selectedHeight);
  }

if (syncmodeparam === "select-pdp" || syncmodeparam === "select-print" ||  syncmodeparam === "pdp-select" || syncmodeparam === "pdp-img" ) {
    let sessionImageData1;
let shouldDisableSizes = false;
let pdpSelectTag;
    if (syncmodeparam === "select-pdp") {
      sessionImageData1 = getLocalStorage1Day("pdp-select-img");  
      pdpSelectTag = getLocalStorage1Day("select-tags");  
    } else if (syncmodeparam === "select-print") {
      sessionImageData1 = getLocalStorage1Day("select-print-image");
      pdpSelectTag = getLocalStorage1Day("select-tags");  
    } else if (syncmodeparam === "pdp-img") {
      sessionImageData1 = getLocalStorage1Day("pdpUploadedImage");
    }  else if(syncmodeparam === "pdp-select") {
      sessionImageData1 = getLocalStorage1Day("frame-select-img");
       pdpSelectTag = getLocalStorage1Day("select-tags");  
    }


    if (pdpSelectTag) {
      try {
        const tags = JSON.parse(pdpSelectTag);
        shouldDisableSizes = tags.includes("style-image") || tags.includes("edit-image");
      } catch (e) {
        console.error(e);
      }
    }

    const disableFrameSizes = [
      '30″×40″',
      '20″×60″',
      '32″×48″',
      '40″×60″',
      '40″×55″',
      '20″×40″',
      '24″×48″',
      '32″×32″',
      '36″×36″',
      '37″×37″'
    ];

   
if (shouldDisableSizes) {

  document.querySelectorAll('#frameSizeOptions input[name="frameSize"]').forEach(input => {

    const frameSize = input.getAttribute("data-frmsize");

    if (disableFrameSizes.includes(frameSize)) {

      input.disabled = true;

      const label = input.closest(".frame-size-btn");

      if (label) {
        label.style.pointerEvents = "none";
        label.style.opacity = "0.5";
        label.style.cursor = "not-allowed";
      }

    }

  });

}
  if (sessionImageData1) {
    galleryWrapper.style.display = "none";
    uploadInputwrap.style.display = "none";
    customForm.style.display = "block";

    const mainImgWrap = document.querySelector(".main-img-wrap");
    if (mainImgWrap) {
      mainImgWrap.setAttribute("data-main-img", sessionImageData1);
    }

    const tempImg = new Image();
    tempImg.onload = function() {

      const imgfileWElement = document.getElementById("img-file-w");
      const imgfileHElement = document.getElementById("img-file-h");

      if (imgfileWElement) imgfileWElement.textContent = tempImg.width;
      if (imgfileHElement) imgfileHElement.textContent = tempImg.height;

      fabric.Image.fromURL(sessionImageData1, function(img) {
        appState.uploadedImage = img;
        appState.uploadedImage.set({
          selectable: true,
          hasBorders: false,
          hasControls: false,
          lockRotation: true,
          lockScalingFlip: true,
          lockUniScaling: true,
          originX: "center",
          originY: "center",
          clipPath: appState.clipPath,
        });

        canvas.add(appState.uploadedImage);
        canvas.setActiveObject(appState.uploadedImage);
        canvas.moveTo(appState.uploadedImage, 2);

           FitFrontFrame();
      });
    
    };
    tempImg.src = sessionImageData1;
  }
}
});

document.addEventListener("DOMContentLoaded", function () {



  function updateVariantId() {
    const size = document.querySelector('input[name="frameSize"]:checked')?.value;
    if (!size  || !window.productVariants) return;

    const variant = window.productVariants.find(
      (v) => v.option1 === size 
    );

    if (!variant) return;

    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = variant.id;

    const variantInputSize = document.querySelector('input[name="properties[_pdp-size]"]');
    if (variantInputSize) variantInputSize.value = size;

    const variantInputId = document.querySelector('input[name="properties[_pdp-variant-id]"]');
    if (variantInputId) variantInputId.value = variant.sku;

    let numericPrice = null;
    let numericCmpPrice = null;

    if (typeof variant.price === "number") {
      numericPrice = variant.price / 100;
    } else if (variant.price?.amount) {
      numericPrice = parseFloat(variant.price.amount);
    } else if (variant.priceV2?.amount) {
      numericPrice = parseFloat(variant.priceV2.amount);
    }

    let finalPrice = numericPrice;
    if (Number.isFinite(numericPrice) && window.isPremiumCustomer === true) {
      finalPrice = numericPrice * 0.9;
    }

    const priceElement = document.querySelector("#price-sale-text");
    if (priceElement) {
      priceElement.textContent = Number.isFinite(finalPrice)
        ? `$${finalPrice.toFixed(2)}`
        : "";
    }

    if (typeof variant.compare_at_price === "number") {
      numericCmpPrice = variant.compare_at_price / 100;
    } else if (variant.compare_at_price?.amount) {
      numericCmpPrice = parseFloat(variant.compare_at_price.amount);
    } else if (variant.compare_at_priceV2?.amount) {
      numericCmpPrice = parseFloat(variant.compare_at_priceV2.amount);
    }

    const cmppriceElement = document.querySelector("#compare-price-text");
    if (cmppriceElement) {
      cmppriceElement.textContent = Number.isFinite(numericCmpPrice)
        ? `$${numericCmpPrice.toFixed(2)}`
        : "";
    }

    const savePrElement = document.querySelector("#save-pr-text");
    if (savePrElement) {
      if (
        Number.isFinite(finalPrice) &&
        Number.isFinite(numericCmpPrice) &&
        numericCmpPrice > finalPrice
      ) {
        const discountPercent = Math.round(
          ((numericCmpPrice - finalPrice) / numericCmpPrice) * 100
        );
        savePrElement.textContent = `${discountPercent}%`;
        savePrElement.style.display = "";
      } else {
        savePrElement.style.display = "none";
      }
    }

    logAllAddedElements();

    const productImage = document.querySelector(".image-magnify-lightbox");
    if (productImage && variant.image) {
      const imageUrl =
        typeof variant.image === "string" ? variant.image : variant.image.src;

      productImage.src = imageUrl;
      const widths = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
      productImage.srcset = widths.map(w => `${imageUrl}?width=${w} ${w}w`).join(", ");
      productImage.alt = variant.image.alt || `${variant.option1} / ${variant.option2}`;
    }
  }

  document
    .querySelectorAll('input[name="frameSize"]')
    .forEach((input) => {
      input.addEventListener("change", updateVariantId);
    });

  updateVariantId();

  // Populate hidden fields on page load from the default checked size radio
  const defaultSize = document.querySelector('input[name="frameSize"]:checked');
  if (defaultSize) defaultSize.dispatchEvent(new Event('change'));

  const defaultColor = document.querySelector('input[name="frameColor"]:checked');
  if (defaultColor) defaultColor.dispatchEvent(new Event('change'));
});

document.addEventListener("DOMContentLoaded", function () {
});

document.querySelectorAll(".image-conform-btn").forEach(btn => {
  btn.addEventListener("click", function (e) {

    sendMainImageToAPI(e);
  });
});

async function sendMainImageToAPI(e) {
  const finalpopup = document.querySelector(".finalize-image-popup");
  const finalpopup1 = document.querySelector("#is-first");
  const finalpopup2 = document.querySelector("#is-second");

  if (finalpopup) finalpopup.style.display = "flex";
  if (finalpopup1) finalpopup1.style.display = "block";
  if (finalpopup2) finalpopup2.style.display = "none";

  const btn = e.currentTarget;
  const originalText = btn.textContent;
  btn.textContent = "Processing...";
  btn.disabled = true;

  try {
    const mainImgWrap = document.querySelector(".main-img-wrap");
    if (!mainImgWrap) throw new Error("No .main-img-wrap element found");

    const imageData = mainImgWrap.getAttribute("data-main-img");
    if (!imageData) throw new Error("No image data found in data-main-img");

    const base64ToBlob = (base64) => {
      const [meta, data] = base64.split(",");
      const mime = meta.match(/:(.*?);/)[1];
      const byteString = atob(data);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], { type: mime });
    };

    const formData = new FormData();
    const userId = window.shopifyCustomerId || "guest";
    const sessionId = getLocalStorage1Day("sessionId") || "none";

    if (imageData.startsWith("http") || imageData.startsWith("//")) {
      formData.append("imageUrl", imageData);
    } else if (imageData.startsWith("data:image/")) {
      formData.append(
        "file",
        base64ToBlob(imageData),
        "uploaded-image.jpeg"
      );
    } else {
      throw new Error("Invalid image data format");
    }

    formData.append("customerId", userId);
    formData.append("sessionId", sessionId);

    const response = await fetch(
      `${window.Prompt2Prints.apiBase}/upload-image`,
      {
        method: "POST",
              headers: {
        "x-api-key": window.Prompt2Prints.apiKey
      },
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error("Image upload API failed");
    }

    const data = await response.json();

const cvswElement = parseFloat(document.getElementById("cvs-w")?.textContent) || 0;
const cvswFinalElement = appState.finalw || 0;
const cvshFinalElement = appState.finalh || 0;
const cvstElement = appState.finalt || 0;
const cvslElement = appState.finall || 0;
              const cvshElement = parseFloat(document.getElementById("cvs-h")?.textContent) || 0;
              const hiddenimg = document.getElementById("frame-img-position");
                 const orientationRadio = document.querySelector('input[name="orientation"]:checked');
    const orientation = orientationRadio ? orientationRadio.value : "portrait";
    if(orientation == "portrait"){
        if (hiddenimg) {
                hiddenimg.value = JSON.stringify({
                  area_width: cvswElement,
                  area_height: cvshElement,
                  width: cvswFinalElement,
                  height: cvshFinalElement,
                  top: cvstElement,
                  left: cvslElement,
                });
              }
    }
    else if(orientation == "landscape"){
      if (hiddenimg) {
                hiddenimg.value = JSON.stringify({
                  area_width: cvswElement,
                  area_height: cvshElement,
                  width: cvswFinalElement,
                  height: cvshFinalElement,
                   top: cvstElement,
                  left: cvslElement,
                });
              }
    }
    const hiddenInput = document.getElementById("final-image-data");
    if (hiddenInput && data.cloudfrontLink) {
      hiddenInput.value = data.cloudfrontLink;
    }

    const frameColor = appState?.frameColor || "default";

    await window.saveCanvasPreviewToAPIAndStorage(
      userId,
      sessionId,
      'my-frame'
    );

    btn.textContent = "Submitted!";
    if (finalpopup1) finalpopup1.style.display = "none";
    if (finalpopup2) finalpopup2.style.display = "block";

  } catch (error) {
    console.error("sendMainImageToAPI error:", error);
    btn.textContent = "Failed. Try again";
  } finally {
    btn.disabled = false;
    setTimeout(() => {
      btn.textContent = originalText;
    }, 2000);
  }
}

async function urlToBase64(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "https://prompt2prints.com";
    img.onload = () => {
      const canvasEl = document.createElement("canvas");
      canvasEl.width = img.width;
      canvasEl.height = img.height;
      const ctx = canvasEl.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvasEl.toDataURL("image/jpeg"));
    };
    img.onerror = reject;
    img.src = url;
  });
}


window.addedElements = [];

window.logAllAddedElements = function() {
   
    window.addedElements.forEach((el, index) => {
    });
};
window.removeSelectedElements = function(indices) {
    indices.sort((a, b) => b - a);

    indices.forEach((i) => {
        if (window.addedElements[i]) {
            canvas.remove(window.addedElements[i]);
            window.addedElements.splice(i, 1);
        }
    });

};
async function reloadImageAsBase64(img) {
  const src = img._element.src;
  const left = img.left;
  const top = img.top;
  const scaleX = img.scaleX;
  const scaleY = img.scaleY;
  const angle = img.angle;
  const originX = img.originX;
  const originY = img.originY;

  const base64 = await urlToBase64(src);

  return new Promise((resolve) => {
    fabric.Image.fromURL(base64, (newImg) => {
      // Calculate innerPadding first
      let innerPadding;
      const size = `${appState.selectedWidth}x${appState.selectedHeight}`;
      
      if (window.innerWidth < 680) {
        if (size === "1056x1248") {
          innerPadding = 144 / 6.24;
        } else if (size === "1152x1440") {
          innerPadding = 144 / 7.2;
        } else if (size === "1344x1632") {
          innerPadding = 144 / 8.16;
        } else if (size === "1440x1440") {
          innerPadding = 144 / 7.2;
        } else if (size === "1440x1824") {
          innerPadding = 144 / 9.12;
        } else if (size === "1440x2016") {
          innerPadding = 144 / 10.08;
        } else if (size === "1824x1824") {
          innerPadding = 144 / 9.12;
        } else if (size === "1824x2208") {
          innerPadding = 144 / 11.04;
        } else if (size === "2016x2592") {
          innerPadding = 144 / 12.96;
        } else if (size === "2208x2976") {
          innerPadding = 144 / 14.88;
        } else if (size === "2208x3168") {
          innerPadding = 144 / 15.84;
        } else if (size === "2592x3360") {
          innerPadding = 144 / 16.8;
        } else if (size === "2592x3744") {
          innerPadding = 144 / 18.72;
        } else {
          innerPadding = null;
        }
      } else {
        if (size === "1056x1248") {
          innerPadding = 144 / 3.12;
        } else if (size === "1152x1440") {
          innerPadding = 144 / 3.6;
        } else if (size === "1344x1632") {
          innerPadding = 144 / 4.08;
        } else if (size === "1440x1440") {
          innerPadding = 144 / 3.6;
        } else if (size === "1440x1824") {
          innerPadding = 144 / 4.56;
        } else if (size === "1440x2016") {
          innerPadding = 144 / 5.04;
        } else if (size === "1824x1824") {
          innerPadding = 144 / 4.56;
        } else if (size === "1824x2208") {
          innerPadding = 144 / 5.52;
        } else if (size === "2016x2592") {
          innerPadding = 144 / 6.48;
        } else if (size === "2208x2976") {
          innerPadding = 144 / 7.44;
        } else if (size === "2208x3168") {
          innerPadding = 144 / 7.92;
        } else if (size === "2592x3360") {
          innerPadding = 144 / 8.4;
        } else if (size === "2592x3744") {
          innerPadding = 144 / 9.36;
        } else {
          innerPadding = null;
        }
      }

      // Create a clipping rectangle to cut innerPadding from the image
      const clipRect = new fabric.Rect({
        left: innerPadding / 2,
        top: innerPadding / 2,
        width: appState.selectedWidth - innerPadding,
        height: appState.selectedHeight - innerPadding,
        absolutePositioned: true
      });

      // Apply the clipping mask to the image
      newImg.clipPath = clipRect;

      // Set position and other properties
      newImg.set({ 
        left, 
        top, 
        scaleX, 
        scaleY, 
        angle, 
        originX, 
        originY 
      });

      // Remove old image and add new one
      canvas.remove(img);
      canvas.add(newImg);
      window.addedElements.push(newImg);

      // Add border (if still needed for visual reference)
      const borderSize = innerPadding;
      const border = new fabric.Rect({
        top: 0,
        left: 0,
        width: appState.selectedWidth - borderSize,
        height: appState.selectedHeight - borderSize,
        fill: 'transparent',
        stroke: 'rgb(0, 0, 0)',
        strokeWidth: borderSize,
        selectable: false,
        evented: false
      });

      canvas.add(border);
      canvas.bringToFront(border);
      window.addedElements.push(border);

      resolve(newImg);
      logAllAddedElements();
    }, {
      crossOrigin: "anonymous"
    });
  });
}

// async function exportFullDivAsImage(customerId, sessionId, frmcolor) {
//   const parentDiv = document.querySelector(".back-image");
//   if (!parentDiv) {
//     console.error("No element with class .back-image found");
//     return;
//   }

//   if (typeof canvas === "undefined") {
//     console.error("Fabric.js canvas not defined");
//     return;
//   }

//   canvas.discardActiveObject();
//   canvas.getObjects().forEach(obj => obj.set({
//     selectable: false,
//     evented: false
//   }));
// const originalBgColor = canvas.backgroundColor || null;

//   canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));

//   canvas.renderAll();

//   try {
//     const images = canvas.getObjects("image");
//     await Promise.all(images.map(img => reloadImageAsBase64(img)));
    

//     // 1️⃣ Export canvas to data URL
//     const dataURL = canvas.toDataURL({
//       format: "jpeg",
//       multiplier: 2,
//     });
//    const frnheight = appState.originalHeight;
//   const frmwidth = appState.originalWidth;
//   let size = `${frmwidth}x${frnheight}`;

//   const sortedSize = [frmwidth, frnheight].sort((a, b) => a - b).join("x");

//   let innerPadding;

//   let paddingMap = {}; 
//    if (window.innerWidth < 680) {
//      paddingMap = {
//         "1056x1248" : 144 / 6.24,
//     "1152x1440" : 144 / 7.2,
//     "1344x1632" : 144 / 8.16,
//     "1440x1440" : 144 / 7.2,
//     "1440x1824" : 144 / 9.12,
//     "1440x2016" : 144 / 10.08,
//     "1824x1824" : 144 / 9.12,
//     "1824x2208" : 144 / 11.04,
//     "2016x2592" : 144 / 12.96,
//     "2208x2976" : 144 / 14.88,
//     "2208x3168" : 144 / 15.84,
//     "2592x3360" : 144 / 16.8,
//     "2592x3744" : 144 / 18.72,
//      }

// } else {
//     paddingMap = {
//         "1056x1248" : 144 / 3.12,
//     "1152x1440" : 144 / 3.6,
//     "1344x1632" : 144 / 4.08,
//     "1440x1440" : 144 / 3.6,
//     "1440x1824" : 144 / 4.56,
//     "1440x2016" : 144 / 5.04,
//     "1824x1824" : 144 / 4.56,
//     "1824x2208" : 144 / 5.52,
//     "2016x2592" : 144 / 6.48,
//     "2208x2976" : 144 / 7.44,
//     "2208x3168" : 144 / 7.92,
//     "2592x3360" : 144 / 8.4,
//     "2592x3744" : 144 / 9.36,
//      }

// }

// function getPadding(size) {
//   // normalize
//   const [w, h] = size.split("x").map(Number);
//   const key = `${Math.min(w,h)}x${Math.max(w,h)}`; // always smaller first
//   return paddingMap[key] ?? null;
// }
// innerPadding = getPadding(size);
// const frmbordercolor = frmcolor;
//     const paddedDataURL = await addPaddingToDataURL(dataURL, innerPadding, frmbordercolor);

//     const res = await fetch(paddedDataURL);
//     const blob = await res.blob();

//     const formData = new FormData();
//      if (blob) {
//   formData.append("file", blob, "full-div-image.jpeg");
// } else if (cloudfrontLink) {
//   formData.append("imageUrl", cloudfrontLink);
// }
//     formData.append("customerId", customerId);
//     formData.append("sessionId", sessionId);
//     formData.append("thumbnailWidth", "200");

//     const response = await fetch(`${window.Prompt2Prints.apiBase}/image-thumbnail`, {
//       method: "POST",
//       body: formData,
//     });

//     const data = await response.json();

//     const hiddenInput = document.getElementById("preview-image-data");
//     if (hiddenInput && data.original?.cloudfrontUrl) hiddenInput.value = data.original.cloudfrontUrl;

//     const hiddenInput1 = document.getElementById("preview-thumb-image-data");
//     if (hiddenInput1 && data.thumbnail?.cloudfrontUrl) hiddenInput1.value = data.thumbnail.cloudfrontUrl;

//     // Optional: display padded image in .full-content
//     let fullContentDiv = document.querySelector(".full-content");
//     if (!fullContentDiv) {
//       fullContentDiv = document.createElement("div");
//       fullContentDiv.className = "full-content";
//       document.body.appendChild(fullContentDiv);
//     }
//     fullContentDiv.innerHTML = "";
//     const imgElement = document.createElement("img");
//     imgElement.src = paddedDataURL;
//     fullContentDiv.appendChild(imgElement);
//     removeSelectedElements([1, 2, 3]);

//   } catch (err) {
//     console.error("Error exporting full div:", err);
//   } finally {
//     canvas.getObjects().forEach(obj => obj.set({
//       selectable: true,
//       evented: true
//     }));
//       canvas.setBackgroundColor(originalBgColor, canvas.renderAll.bind(canvas));
//     canvas.renderAll();
//   }
// }
// function addPaddingToDataURL(dataURL, padding = 50, bgColor) {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.src = dataURL;
//     img.onload = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = img.width + padding * 2;
//       canvas.height = img.height + padding * 2;
//       const ctx = canvas.getContext("2d");
//       ctx.fillStyle = bgColor;
//       ctx.fillRect(0, 0, canvas.width, canvas.height);
//       ctx.drawImage(img, padding, padding);

//       resolve(canvas.toDataURL("image/jpeg"));
//     };
//   });
// }

async function reloadImageAsBase64(img) {

  const src = img._element.src;
  const left = img.left;
  const top = img.top;
  const scaleX = img.scaleX;
  const scaleY = img.scaleY;
  const angle = img.angle;
  const originX = img.originX;
  const originY = img.originY;

  const base64 = await urlToBase64(src);

  return new Promise((resolve) => {
    fabric.Image.fromURL(base64, (newImg) => {
      newImg.set({ left, top, scaleX, scaleY, angle, originX, originY });

      // 🔴 REMOVE CENTER GUIDE LINES
      canvas.getObjects('line').forEach((obj) => {
        if (obj.stroke === 'red' && obj.opacity === 0.5) {
          canvas.remove(obj);
        }
      });

      canvas.remove(img);
      canvas.setBackgroundColor("#ffffff", canvas.renderAll.bind(canvas));

      canvas.add(newImg);
      window.addedElements.push(newImg);

      // ---------------- INNER PADDING LOGIC ----------------
      let innerPadding;
      const size = `${appState.originalWidth}x${appState.originalHeight}`;

      if (window.innerWidth < 680) {
        if (size === "1056x1248") innerPadding = 144 / 6.24;
        else if (size === "1152x1440") innerPadding = 144 / 7.2;
        else if (size === "1344x1632") innerPadding = 144 / 8.16;
        else if (size === "1440x1440") innerPadding = 144 / 7.2;
        else if (size === "1440x1824") innerPadding = 144 / 9.12;
        else if (size === "1440x2016") innerPadding = 144 / 10.08;
        else if (size === "1824x1824") innerPadding = 144 / 9.12;
        else if (size === "1824x2208") innerPadding = 144 / 11.04;
        else if (size === "2016x2592") innerPadding = 144 / 12.96;
        else if (size === "2208x2976") innerPadding = 144 / 14.88;
        else if (size === "2208x3168") innerPadding = 144 / 15.84;
        else if (size === "2592x3360") innerPadding = 144 / 16.8;
        else if (size === "2592x3744") innerPadding = 144 / 18.72;
        else innerPadding = null;
      } else {
        if (size === "1056x1248") innerPadding = 144 / 3.12;
        else if (size === "1152x1440") innerPadding = 144 / 3.6;
        else if (size === "1344x1632") innerPadding = 144 / 4.08;
        else if (size === "1440x1440") innerPadding = 144 / 3.6;
        else if (size === "1440x1824") innerPadding = 144 / 4.56;
        else if (size === "1440x2016") innerPadding = 144 / 5.04;
        else if (size === "1824x1824") innerPadding = 144 / 4.56;
        else if (size === "1824x2208") innerPadding = 144 / 5.52;
        else if (size === "2016x2592") innerPadding = 144 / 6.48;
        else if (size === "2208x2976") innerPadding = 144 / 7.44;
        else if (size === "2208x3168") innerPadding = 144 / 7.92;
        else if (size === "2592x3360") innerPadding = 144 / 8.4;
        else if (size === "2592x3744") innerPadding = 144 / 9.36;
        else innerPadding = null;
      }

      const borderSize = innerPadding;
      console.log("bordersize---", borderSize);

      const frmcolor1 = appState.frameColor;

      const border = new fabric.Rect({
        top: 0,
        left: 0,
        width: appState.selectedWidth - borderSize,
        height: appState.selectedHeight - borderSize,
        fill: 'transparent',
        stroke: frmcolor1,
        strokeWidth: borderSize,
        selectable: false,
        evented: false
      });

      canvas.add(border);
      canvas.bringToFront(border);
      window.addedElements.push(border);

      resolve(newImg);
      logAllAddedElements();

    }, { crossOrigin: "anonymous" });
  });
}



async function exportFullDivAsImage(customerId, sessionId, frmcolor) {
  const parentDiv = document.querySelector(".back-image");
  if (!parentDiv) {
    console.error("No element with class .back-image found");
    return;
  }

  if (typeof canvas === "undefined") {
    console.error("Fabric.js canvas not defined");
    return;
  }

  canvas.discardActiveObject();
  canvas.getObjects().forEach(obj => obj.set({
    selectable: false,
    evented: false
  }));

  canvas.renderAll();

 
  try {
    const images = canvas.getObjects("image");
    await Promise.all(images.map(img => reloadImageAsBase64(img)));
    

    // 1️⃣ Export canvas to data URL
    const dataURL = canvas.toDataURL({
      format: "jpeg",
      multiplier: 2,
    });
const frmbordercolor = frmcolor;
    const paddedDataURL = await addPaddingToDataURL(dataURL, 0, frmbordercolor);

    const res = await fetch(paddedDataURL);
    const blob = await res.blob();

    const formData = new FormData();
    formData.append("file", blob, "full-div-image.jpeg");
    formData.append("customerId", customerId);
    formData.append("sessionId", sessionId);
    formData.append("thumbnailWidth", "200");

    const response = await fetch(`${window.Prompt2Prints.apiBase}/image-thumbnail`, {
      method: "POST",
              headers: {
        "x-api-key": window.Prompt2Prints.apiKey
      },
      body: formData,
    });

    const data = await response.json();

    const hiddenInput = document.getElementById("preview-image-data");
    if (hiddenInput && data.original?.cloudfrontUrl) hiddenInput.value = data.original.cloudfrontUrl;

    const hiddenInput1 = document.getElementById("preview-thumb-image-data");
    if (hiddenInput1 && data.thumbnail?.cloudfrontUrl) hiddenInput1.value = data.thumbnail.cloudfrontUrl;

    // Optional: display padded image in .full-content
    let fullContentDiv = document.querySelector(".full-content");
    if (!fullContentDiv) {
      fullContentDiv = document.createElement("div");
      fullContentDiv.className = "full-content";
      document.body.appendChild(fullContentDiv);
    }
    fullContentDiv.innerHTML = "";
    const imgElement = document.createElement("img");
    imgElement.src = paddedDataURL;
    fullContentDiv.appendChild(imgElement);
    removeSelectedElements([1, 2, 3]);

  } catch (err) {
    console.error("Error exporting full div:", err);
  } finally {
    canvas.getObjects().forEach(obj => obj.set({
      selectable: true,
      evented: true
    }));
    canvas.renderAll();
  }
}

// Helper function: add padding to a dataURL
function addPaddingToDataURL(dataURL, padding, bgColor) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = dataURL;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width + padding * 2;
      canvas.height = img.height + padding * 2;
      const ctx = canvas.getContext("2d");

      if(bgColor === "#FFFFFF"){
        ctx.fillStyle = "#000000";
      } 
      else {
        ctx.fillStyle = "#FFFFFF";
      }
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw original image in center
      ctx.drawImage(img, padding, padding);

      resolve(canvas.toDataURL("image/jpeg"));
    };
  });
}

function captureImageTransform(image) {
  if (!image) return null;

  return {
    left: image.left,
    top: image.top,
    angle: image.angle,
    originX: image.originX || "left",
    originY: image.originY || "top",

    // ✅ visible size in canvas px
    visibleWidth: image.getScaledWidth(),
    visibleHeight: image.getScaledHeight()
  };
}


function applyImageTransform(image, transform) {
  if (!image || !transform) return;

  const scaleX = transform.visibleWidth / image.width;
  const scaleY = transform.visibleHeight / image.height;

  image.set({
    left: transform.left,
    top: transform.top,
    angle: transform.angle,
    originX: transform.originX,
    originY: transform.originY,
    scaleX,
    scaleY
  });

  image.setCoords();
}


async function upscaleAndFixDPI({
  sessionId = "none",
  customerId = "guest",
  dpi = null,
  printHeight = null,
  printWidth = null,
  imageUrl = null,
  file = null,
  callback = null 
}) {
 const savepopup = document.querySelector(".save-image-popup");
  const afterSavePopup = document.querySelector("#aftersavepopup"); // Get the after save popup
  
   if (savepopup) savepopup.style.display = "flex";
  if (afterSavePopup) afterSavePopup.style.display = "none"; // Ensure it's hidden initially

const savepopuptitle = document.querySelector(".save-image-title");
const savepopupicon = document.querySelector(".save-image-icon");
const savepopuptext = document.querySelector(".save-image-text");

if (savepopupicon) savepopupicon.style.display = "flex";

savepopuptitle.textContent = "Boosting Image";
savepopuptext.textContent = "Boosting resolution for maximum clarity";

  // 🔹 SAVE CURRENT IMAGE TRANSFORM
  const previousTransform = captureImageTransform(appState.uploadedImage);

  const imagefinalWidth = (appState.imageWidth * 300) / appState.dpi;
  const imagefinalHeight = (appState.imageheight * 300) / appState.dpi;

const imagesize = appState.uploadimgsize;
 const formData = new FormData();
 
  formData.append("sessionId", sessionId);
  formData.append("customerId", customerId);
  if (dpi) formData.append("dpi", dpi);
  if (printWidth) formData.append("printWidth", printWidth);
  if (printHeight) formData.append("printHeight", printHeight);
  formData.append("format", "jpeg");
  formData.append("faceEnhancement", "true");
   formData.append("finalWidth", imagefinalWidth);
  formData.append("finalHeight", imagefinalHeight);
const currentPageUrl = window.location.href; 
formData.append("page_url", currentPageUrl); 
  if (imageUrl) formData.append("imageUrl", imageUrl);
 if (file) {
    formData.append("file", file);
  formData.append("isDirectUpload", "true");
  
      formData.append("inputImageSizeMB", imagesize);
  }

  try {
    const response = await fetch(`${window.Prompt2Prints.apiBase}/boost-image`, {
      method: "POST",
              headers: {
        "x-api-key": window.Prompt2Prints.apiKey
      },
      body: formData,
    });

   if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    const result = await response.json();
      if (result?.error) {
      throw new Error(result.error);
    }

     const enhancedUrl = result?.enhanced;
    if (!enhancedUrl) {
      throw new Error("No enhanced URL returned");
    }

    const mainImgWrap = document.querySelector(".main-img-wrap");
    if (mainImgWrap) {
      mainImgWrap.setAttribute("data-main-img", enhancedUrl);
      mainImgWrap.innerHTML = `<img src="${enhancedUrl}" style="max-width:100%;">`;
    }


    fabric.Image.fromURL(enhancedUrl, async (img) => {
   
      canvas.clear();
      // set white background
canvas.setBackgroundColor('#ffffff', canvas.renderAll.bind(canvas));
      appState.uploadedImage = img;
      appState.uploadedImage.set({
        selectable: true,
        hasBorders: false,
        hasControls: false,
        lockRotation: true,
        lockScalingFlip: true,
        lockUniScaling: true,
        originX: "center",
        originY: "center",
        clipPath: appState.clipPath || null,
      });

      canvas.add(appState.uploadedImage);
     // 🔹 RESTORE EXACT SAME POSITION
      if (previousTransform) {
        applyImageTransform(appState.uploadedImage, previousTransform);
      } else {
        canvas.centerObject(appState.uploadedImage);
      }

      setMovementConstraints();
      canvas.setActiveObject(appState.uploadedImage);
      canvas.renderAll();

      const imgfileWElement = document.getElementById("img-file-w");
      const imgfileHElement = document.getElementById("img-file-h");

     document.getElementById("img-file-w").textContent =
        appState.uploadedImage.width || 0;
      document.getElementById("img-file-h").textContent =
        appState.uploadedImage.height || 0;
 await updatePositionInfo();

      const slider = document.getElementById("zoomSlider");
      if (slider) {
       
        updateSliderBackground(slider);
        syncZoomSlider(); // Sync zoom slider after upscale
      }



  
      // 🔹 Inline DPI display logic
      const dpiElement = document.querySelector(".dpi-num");
      const iconElement = document.querySelector(".dpi-state-icon");
      const boostBtn = document.querySelector(".boost-img-btn");
      const currentDpi = Number((appState.dpi || 0).toFixed(2));
      if (dpiElement && iconElement && boostBtn) {
        
        iconElement.innerHTML = ""; // clear old icon

       

  iconElement.innerHTML = ""; // clear old icon

  if (currentDpi < 30) {
  dpiElement.textContent = `Needs Upscale`;
    dpiElement.style.color = "red";

    iconElement.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.9891 0C4.49317 0 0 4.49317 0 9.9891C0 15.4859 4.49317 20 9.9891 20C15.485 20 20 15.5068 20 9.9891C20 4.47115 15.5068 0 9.9891 0ZM9.9891 18.3208C5.40912 18.3208 1.67946 14.5911 1.67946 10.0111C1.67946 5.43115 5.40912 1.70148 9.9891 1.70148C14.5691 1.70148 18.2987 5.43115 18.2987 10.0111C18.3207 14.5911 14.5909 18.3208 9.9891 18.3208Z" fill="#FF0606"/>
      <path d="M10.1207 4.56252C9.74952 4.56252 9.44421 4.69326 9.20466 4.93365C8.98621 5.1732 8.85547 5.52239 8.85547 5.93651C8.85547 6.24185 8.8774 6.72177 8.92126 7.41931L9.16081 10.9307C9.20466 11.4106 9.29154 11.7379 9.37926 11.9774C9.48806 12.2389 9.70651 12.3696 10.0118 12.3696C10.3172 12.3696 10.5137 12.2389 10.6444 11.9774C10.7532 11.7379 10.841 11.3887 10.8629 10.9526L11.1682 7.33156C11.2121 7.0043 11.2121 6.65511 11.2121 6.34977C11.2121 5.78297 11.1463 5.34691 10.9936 5.04073C10.884 4.7371 10.5787 4.56252 10.1207 4.56252Z" fill="#FF0606"/>
      <path d="M10.0549 13.4844C9.72761 13.4844 9.44421 13.5932 9.20466 13.8336C8.96511 14.0731 8.85547 14.3354 8.85547 14.6627C8.85547 15.0338 8.9862 15.3391 9.2266 15.5348C9.46615 15.7313 9.75039 15.8402 10.0768 15.8402C10.3821 15.8402 10.6655 15.7313 10.9059 15.5129C11.1455 15.2944 11.277 14.6408 11.277 14.6408C11.277 14.3135 11.1682 14.0301 10.9278 13.7906C10.6655 13.5932 10.3813 13.4844 10.0549 13.4844Z" fill="#FF0606"/>
    </svg>`;

    boostBtn.style.display = "flex";
    boostBtn.classList.add("show");
  } else if (currentDpi > 300){
   dpiElement.textContent = `Good To Print`;
    dpiElement.style.color = "green";

    iconElement.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0C4.48421 0 0 4.48421 0 10C0 15.5158 4.48421 20 10 20C15.5158 20 20 15.5158 20 10C20 4.48421 15.5158 0 10 0ZM10 17.8105C5.68421 17.8105 2.18947 14.2947 2.18947 10C2.18947 5.70526 5.68421 2.18947 10 2.18947C14.3158 2.18947 17.8105 5.68421 17.8105 10C17.8105 14.3158 14.3158 17.8105 10 17.8105Z" fill="#1B8600"/>
      <path d="M12.7139 6.92258L8.90337 10.7542L7.28232 9.13311C6.86127 8.71205 6.16653 8.71205 5.74548 9.13311C5.32442 9.55416 5.32442 10.2489 5.74548 10.6699L8.14548 13.0699C8.356 13.2805 8.62969 13.3857 8.92443 13.3857C9.21916 13.3857 9.49285 13.2805 9.70337 13.0699L14.2928 8.48047C14.7139 8.05942 14.7139 7.36469 14.2928 6.94363C13.8507 6.50153 13.156 6.50153 12.7139 6.92258Z" fill="#1B8600"/>
    </svg>`;

    boostBtn.classList.remove("show");
    if (!boostBtn.classList.contains("show")) {
      boostBtn.style.display = "none";
    }
  } else if (currentDpi == 0) {
 boostBtn.classList.remove("show");
    setTimeout(() => {
      if (!boostBtn.classList.contains("show")) {
        boostBtn.style.display = "none"; 
         document.querySelector(".image-conform-btn").style.display = "flex";
      }
    }, 300);
  }
      }

    });

        if (result?.message === "We can not upscale this image further. Please try a different image."
) {
  console.log(result.message);
  if (savepopup) savepopup.style.display = "flex";
const savepopuptitle = document.querySelector(".save-image-title");
const savepopupicon = document.querySelector(".save-image-icon");
const savepopuptext = document.querySelector(".save-image-text");
const boostBtns = document.querySelectorAll(".boost-img-btn");

boostBtns.forEach(btn => {
  btn.classList.add("limit-reached");
});
if (savepopupicon) savepopupicon.style.display = "none";

if (result?.message === "We can not upscale this image further. Please try a different image.") {
  savepopuptitle.textContent = "Change Image";
  savepopuptext.textContent =
    "The image has reached its maximum resolution and cannot be upscaled further.";
}

   setTimeout(() => {
      if (savepopup) savepopup.style.display = "none";
    }, 3000);
} else {
 // Show aftersave popup and hide savepopup after delay
    if (savepopup) savepopup.style.display = "none";
    
    if (afterSavePopup) {
      afterSavePopup.style.display = "flex";
      
      // Hide aftersave popup after 3-4 seconds
      setTimeout(() => {
        afterSavePopup.style.display = "none";
      }, 3500); // 3.5 seconds
    }
}

  }
  catch (err) {
      console.error("Upscale API failed:", err);
     if (savepopup) savepopup.style.display = "flex";

      const savepopuptitle = document.querySelector(".save-image-title");
      const savepopupicon = document.querySelector(".save-image-icon");
      const savepopuptext = document.querySelector(".save-image-text");

      if (savepopupicon) savepopupicon.style.display = "none";

      if (err.message === "We can not upscale this image further. Please try a different image.") {
        savepopuptitle.textContent = "Change Image";
        savepopuptext.textContent =
          "The image has reached its maximum resolution and cannot be upscaled further.";
      } else {
        savepopuptitle.textContent = "Upscale Failed";
        savepopuptext.textContent =
          "There was an issue while upscaling the image. Please try again.";
      }

  // Hide popup after 3 seconds
    setTimeout(() => {
      if (savepopup) savepopup.style.display = "none";
    }, 3000);
  }
}

function base64ToFile(base64, filename = "image.jpeg") {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}



function getCroppedCanvas() {
  let innerPadding;
  
    const frnheight = appState.orgHeight;
  const frmwidth = appState.orgWidth;
  const size = `${appState.selectedWidth}x${appState.selectedHeight}`;
if (window.innerWidth < 680) {
     if (size === "1056x1248") {
    innerPadding = 144 / 6.24;
    } else if (size === "1152x1440") {
    innerPadding = 144 / 7.2;
    } else if (size === "1344x1632") {
    innerPadding = 144 / 8.16;
    } else if (size === "1440x1440") {
    innerPadding = 144 / 7.2;
    } else if (size === "1440x1824") {
    innerPadding = 144 / 9.12;
    } else if (size === "1440x2016") {
    innerPadding = 144 / 10.08;
    } else if (size === "1824x1824") {
    innerPadding = 144 / 9.12;
    } else if (size === "1824x2208") {
    innerPadding = 144 / 11.04;
    } else if (size === "2016x2592") {
    innerPadding = 144 / 12.96;
    } else if (size === "2208x2976") {
    innerPadding = 144 / 14.88;
    } else if (size === "2208x3168") {
    innerPadding = 144 / 15.84;
    } else if (size === "2592x3360") {
    innerPadding = 144 / 16.8;
    } else if (size === "2592x3744") {
    innerPadding = 144 / 18.72;
    } else {
    innerPadding = null;
    }
} else {
     if (size === "1056x1248") {
    innerPadding = 144 / 3.12;
    } else if (size === "1152x1440") {
    innerPadding = 144 / 3.6;
    } else if (size === "1344x1632") {
    innerPadding = 144 / 4.08;
    } else if (size === "1440x1440") {
    innerPadding = 144 / 3.6;
    } else if (size === "1440x1824") {
    innerPadding = 144 / 4.56;
    } else if (size === "1440x2016") {
    innerPadding = 144 / 5.04;
    } else if (size === "1824x1824") {
    innerPadding = 144 / 4.56;
    } else if (size === "1824x2208") {
    innerPadding = 144 / 5.52;
    } else if (size === "2016x2592") {
    innerPadding = 144 / 6.48;
    } else if (size === "2208x2976") {
    innerPadding = 144 / 7.44;
    } else if (size === "2208x3168") {
    innerPadding = 144 / 7.92;
    } else if (size === "2592x3360") {
    innerPadding = 144 / 8.4;
    } else if (size === "2592x3744") {
    innerPadding = 144 / 9.36;
    } else {
    innerPadding = null;
    }

}



  const sw = canvas.width - innerPadding * 2;
  const sh = canvas.height - innerPadding * 2;

  mockupState.croppedWidth = sw;
  mockupState.croppedHeight = sh;

  const cropped = document.createElement("canvas");
  cropped.width = sw;
  cropped.height = sh;
  const ctx = cropped.getContext("2d");

  ctx.drawImage(
    canvas.lowerCanvasEl,
    innerPadding, innerPadding, sw, sh,
    0, 0, sw, sh
  );

  return cropped;
}

function insertIntoMockups() {
  const croppedCanvas = getCroppedCanvas();
  const mockupCanvases = document.querySelectorAll(".mockup-canvas");

  mockupCanvases.forEach((mockupCanvas, index) => {
    const ctx = mockupCanvas.getContext("2d");
    ctx.clearRect(0, 0, mockupCanvas.width, mockupCanvas.height);

    const { x, y, w, h } = mockupPlacements[index];

    ctx.drawImage(
      croppedCanvas,
      mockupCanvas.width * x,
      mockupCanvas.height * y,
      mockupCanvas.width * w,
      mockupCanvas.height * h
    );
  });
}

document.getElementById("insertBtn")?.addEventListener("click", insertIntoMockups);



 document.addEventListener("DOMContentLoaded", () => {
    const currentUrl = window.location.pathname; 
    const links = document.querySelectorAll(".pdp-tab-wrap .pill");

    links.forEach(link => {
      if (link.getAttribute("href") === currentUrl) {
        link.classList.add("active");
      }
    });
  });


document.addEventListener("DOMContentLoaded", function () {

  const highlightedOptions = [];

  const relatedOptionsMap = {
    '9″×12″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
    '12″×16″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
    '18″×24″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
    '24″×32″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
    '30″×40″': ["18″×26″", "20″×28″", "28″×40″", "40″×55″"],
    '8″×12″': ["26″×40″"],
    '12″×18″': ["26″×40″"],
    '16″×24″': ["26″×40″"],
    '20″×30″': ["26″×40″"],
    '24″×36″': ["26″×40″"],
    '32″×48″': ["26″×40″"],
    '40″×60″': ["26″×40″"],
    '8″×10″': ["11″×14″", "20″×24″"],
    '16″×20″': ["11″×14″", "20″×24″"],
    '24″×30″': ["11″×14″", "20″×24″"],
  };

  function highlightMatchingOption() {
   

    const imgRatioEl = document.getElementById("img-ratio");
    if (!imgRatioEl) {
      console.warn("⚠️ No element found with id 'img-ratio'");
      return;
    }

    const ratioValue = imgRatioEl.textContent.trim() || imgRatioEl.value?.trim();
 

    if (!ratioValue) {
    
      return false;
    }

    const options = document.querySelectorAll("#frameSizeOptions label.frame-size-btn input");

    let matchFound = false;

    options.forEach((input, index) => {
      const lRatio = input.getAttribute("data-l-ratio");
      const pRatio = input.getAttribute("data-p-ratio");
      const label = input.closest("label.frame-size-btn").querySelector("span");

      if (ratioValue === lRatio || ratioValue === pRatio) {
        label.style.border = "1px solid green";
         
        matchFound = true;

        if (!highlightedOptions.includes(input.value)) {
          highlightedOptions.push(input.value);
        }
      } else {
        label.style.border = "1px solid #333";
      }
    });

    if (!matchFound) {
      console.warn("⚠️ No exact match found for ratio:", ratioValue);
    } else {
    

      highlightedOptions.forEach((val) => {
        if (relatedOptionsMap[val]) {
          relatedOptionsMap[val].forEach((relatedVal) => {
            highlightRelatedOption(relatedVal);
          });
        } 
      });
    }

    return true;
  }

  function highlightRelatedOption(targetValue) {

    const options = document.querySelectorAll("#frameSizeOptions label.frame-size-btn input");
    let found = false;

    options.forEach((input) => {
      const normalizedInput = input.value.replace(/[“”"]/g, '"').replace(/[×x]/g, "x");
      const normalizedTarget = targetValue.replace(/[“”"]/g, '"').replace(/[×x]/g, "x");

      if (normalizedInput === normalizedTarget) {
        const label = input.closest("label.frame-size-btn").querySelector("span");
        label.style.border = "1px solid orange";
         
        found = true;

        if (!highlightedOptions.includes(input.value)) {
          highlightedOptions.push(input.value);
        }
      }
    });

    if (!found) {
      console.warn(`❌ Related option not found for "${targetValue}"`);
    }
  }

  const ratioCheckInterval = setInterval(() => {
    const done = highlightMatchingOption();
    if (done) {
      clearInterval(ratioCheckInterval);
    } 
  }, 300);
});



document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".pdp-option-main-wrap");

  items.forEach(item => {
    const header = item.querySelector(".pdp-option-title-wrap.is-layout");
    const content = item.querySelector(".orientation-options");
    const arrow = item.querySelector(".pdp-option-arrow");

    if (!header || !content) return;

    content.style.display = "none";

    // Default open
    if (item.classList.contains("default-open")) {
      item.classList.add("active");
      header.setAttribute("aria-expanded", "true");
      content.style.display = "grid";
      if (arrow) arrow.style.transform = "rotate(180deg)";
    }

    header.addEventListener("click", () => {
      const expanded = header.getAttribute("aria-expanded") === "true";

      item.classList.toggle("active");
      header.setAttribute("aria-expanded", !expanded);

      if (expanded) {
        content.style.display = "none";
        if (arrow) arrow.style.transform = "rotate(0deg)";
      } else {
        content.style.display = "grid";
        if (arrow) arrow.style.transform = "rotate(180deg)";
      }
    });
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//   const items = document.querySelectorAll(".frame-sizes");

//   items.forEach(item => {
//     const header = item.querySelector(".pdp-option-title-wrap.is-size");
//     const content = item.querySelector(".frame-size-options");
//     const arrow = item.querySelector(".pdp-option-arrow");

//     if (!header || !content) return;

//     content.style.display = "none";

//     // Default open
//     if (item.classList.contains("default-open")) {
//       item.classList.add("active");
//       header.setAttribute("aria-expanded", "true");
//       content.style.display = "flex";
//       if (arrow) arrow.style.transform = "rotate(180deg)";
//     }

//     header.addEventListener("click", () => {
//       const expanded = header.getAttribute("aria-expanded") === "true";

//       item.classList.toggle("active");
//       header.setAttribute("aria-expanded", !expanded);

//       if (expanded) {
//         content.style.display = "none";
//         if (arrow) arrow.style.transform = "rotate(0deg)";
//       } else {
//         content.style.display = "flex";
//         if (arrow) arrow.style.transform = "rotate(180deg)";
//       }
//     });
//   });
// });



